<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="mini"
      :toolbar-config="tableToolbar"
      :data="viewTableData"
      :columns="tableColumns"
      :loading="loading"
      :span-method="mergeRowMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:fabricCategory="{ column }">
        <div style="text-align: center;">
          <el-dropdown size="small" trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ column.title }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ ...opt, params: column.params }"
                :divided="opt.divided"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      format: (number) => format(number),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ visible }) => visible == undefined || visible)
    },
    isEmpty() {
      return !this.tableData || !this.tableData.length
    },
    columnGroup() {
      if (this.isEmpty) return []
      return this.tableData.map((item) => {
        const fabricNameRanges = JSON.parse(item.fabricNameRangeJson || '[]')
        const fabricName = fabricNameRanges
          .map((range) => range.label)
          .join('、')
        return {
          title: item.fabricCategoryName,
          align: 'center',
          slots: { header: 'fabricCategory' },
          params: item,
          children: [
            {
              title: !fabricName ? '' : `(${fabricName})`,
              field: `${item.pdProcessDictFabricCode}.labourCost`,
              minWidth: 160,
              align: 'center',
              formatter: ({ row }) => {
                const { labourCost, techDesc } =
                  row[item.pdProcessDictFabricCode] || {}
                if (labourCost == null || labourCost == undefined) return
                return [this.format(labourCost), techDesc]
                  .filter(Boolean)
                  .join('/')
              },
            },
          ],
        }
      })
    },
    tableColumns() {
      const baseColumns = tableColumns(this)
      if (this.isEmpty) return baseColumns
      return baseColumns.concat(this.columnGroup)
    },
    viewTableData() {
      if (this.isEmpty) return []

      const data = this.tableData
        .map((item) =>
          item.listTech.map((tech) => ({
            ...tech,
            pdProcessDictFabricCode: item.pdProcessDictFabricCode,
            fabricCategoryCode: item.fabricCategoryCode,
            fabricCategoryName: item.fabricCategoryName,
            displayCategoryCode: item.displayCategoryCode,
            displayCategoryName: item.displayCategoryName,
          }))
        )
        .reduce((r, n) => {
          r.push(...n)
          return r
        }, [])

      const group = data
        .map(
          (item) =>
            `${item.pdProcessDictStep}/${item.techName}/${item.techChargeUnit}`
        )
        .reduce((acc, val, i) => {
          acc[val] = (acc[val] || []).concat(data[i])
          return acc
        }, {})

      const showData = Object.keys(group)
        .sort()
        .map((key) => {
          const items = group[key]
          let result
          for (let item of items) {
            if (!result) result = { ...item }
            result[item.pdProcessDictFabricCode] = {
              pdProcessDictFabricCode: item.pdProcessDictFabricCode,
              fabricCategoryCode: item.fabricCategoryCode,
              fabricCategoryName: item.fabricCategoryName,
              displayCategoryCode: item.displayCategoryCode,
              displayCategoryName: item.displayCategoryName,
              labourCost: item.labourCost,
              techDesc: item.techDesc,
            }
          }
          return result
        })

      return showData
    },
    mergeCellByKey() {
      const mergeByKey = this.tableColumns.find((c) => c.mergeByKey)
      return mergeByKey ? mergeByKey.field : ''
    },
    mergeCell() {
      return this.tableColumns.filter((c) => c.merge).map((c) => c.field)
    },
  },
  methods: {
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      if (!this.mergeCellByKey) {
        return { rowspan: 1, colspan: 1 }
      }
      const fields = this.mergeCell
      const cellValue = row[this.mergeCellByKey]

      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]

        if (prevRow && prevRow[this.mergeCellByKey] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[this.mergeCellByKey] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    optCommand({ menuType, params }) {
      if ('delete' === menuType) return this.del(params)
      this.$emit('openEditForm', { type: menuType, params })
    },
    del({ pdProcessDictFabricCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryFabricDelApi({ pdProcessDictFabricCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dropdown {
    font-size: 12px;
  }
}
</style>
